export default function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/utils/expandToHashMap.js
// module id = 583
// module chunks = 0 2 3 4 5